import { IRoundTeesAssignation } from '../../../../../../../store/roundTees/store';

type TGetEmptyFlight = (roundId: number | string) => IRoundTeesAssignation;

export const getEmptyRoundTeeAssignation: TGetEmptyFlight = roundId => ({
  ageLower: null,
  ageUpper: null,
  gender: null,
  handicapLower: null,
  handicapUpper: null,
  id: -1,
  round: Number(roundId),
  tee: undefined
});
